// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22 2H2V22H14.3895C13.8269 21.1372 13.5 20.1068 13.5 19C13.5 15.9624 15.9624 13.5 19 13.5C20.1068 13.5 21.1372 13.8269 22 14.3895V2ZM15 7V9H13V14.5C13 15.8807 11.8807 17 10.5 17C9.11929 17 8 15.8807 8 14.5C8 13.1193 9.11929 12 10.5 12C10.6712 12 10.8384 12.0172 11 12.05V7H15Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M20 20H23V18H20V15H18V18H15V20H18V23H20V20Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-music-rectangle-add-filled')
export default class MusicRectangleAddFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'music-rectangle-add-filled',
    }
  }
}
